import type { FiltersType } from '@customTypes/filters';
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router';

type Props = {
  onParamsChange: (filters: FiltersType) => void;
};

const usePaginationParams = ({ onParamsChange }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialized = useRef(false);

  useEffect(() => {
    const paramsObj = Object.fromEntries(searchParams.entries());

    const filters: FiltersType = {
      ...paramsObj,
      page: Number(paramsObj.page || 1),
      limit: Number(paramsObj.limit || 10),
    };

    const newParams = new URLSearchParams(searchParams);

    if (!paramsObj.page) newParams.set('page', String(filters.page));
    if (!paramsObj.limit) newParams.set('limit', String(filters.limit));

    const urlChanged = Array.from(newParams.entries()).toString() !== Array.from(searchParams.entries()).toString();

    if (urlChanged) {
      setSearchParams(newParams);
      return;
    }

    if (!initialized.current) {
      initialized.current = true;
      onParamsChange(filters);
    }
  }, [searchParams, onParamsChange]);

  return null;
};

export default usePaginationParams;
